<template lang="pug">
    div.hidden
        el-form-item(prop="gender")
        el-form-item(prop="first_name")
        el-form-item(prop="last_name")
        el-form-item(prop="email")
        el-form-item(prop="password")
        div(v-for="(address, index) in addresses")
            el-form-item(:prop="'addresses.' + index + '.street'")
            el-form-item(:prop="'addresses.' + index + '.zipcode'")
            el-form-item(:prop="'addresses.' + index + '.city'")
            el-form-item(:prop="'addresses.' + index + '.country'")
                el-form-item(v-if="addresses.length > 1" :prop="'addresses.' + index + '.defaultSwitches'")
        .shop(v-if="enabledExtensions.includes('shop')")
            el-form-item(v-if="customerNr !== undefined" prop="customer.nr")
            el-form-item(prop="customer.customerGroup")
</template>

<script>

import _ from 'lodash'
import { useSetupStore, useRestrictedAreaMemberStore } from '@/stores'

export default {
    name: 'AllInputFields',
    computed: {
        memberStore() {
            return useRestrictedAreaMemberStore();
        },
        form() {
            return this.memberStore.form;
        },
        customerNr() {
            return _.get(this.form, 'customer.nr')
        },
        addresses() {
            return _.get(this.form, 'addresses') || []
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        }
    }
}
</script>
